import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerRightUp"><Path d="M4.5 20.5H15V4" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 8L15 3.5L19.5 8" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerRightUp;
